module.exports = __webpack_public_path__ + "img/Firefox_Screenshot_2021-10-29T11-15-01.253Z.1b78cbf8.png";